/**
 * Smooth scroll provider — Lenis
 * Intercepta o scroll nativo e interpola com easing.
 * É o que dá a sensação de "manteiga" do Active Theory.
 */
import { useEffect } from "react";
import Lenis from "lenis";

export function useSmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      // mouse wheel multiplier — quanto maior, mais "intenso" cada giro
      wheelMultiplier: 1.0,
      touchMultiplier: 1.2,
      smoothWheel: true,
    });

    let raf: number;
    function loop(time: number) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    }
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}
